const AUTH_LOGIN_ENDPOINT_PATH = '/api/clients-dmp/v1/auth/login';
const AUTH_LOGOUT_ENDPOINT_PATH = '/api/clients-dmp/v1/auth/logout';

const getAuthLoginEndpointUrl = () => AUTH_LOGIN_ENDPOINT_PATH;

const getAuthLogoutEndpointUrl = () => AUTH_LOGOUT_ENDPOINT_PATH;

export { AUTH_LOGIN_ENDPOINT_PATH, AUTH_LOGOUT_ENDPOINT_PATH, getAuthLoginEndpointUrl, getAuthLogoutEndpointUrl };
